<template>
  <div>
    <div v-for="item in combinedList" :key="item.index + item.id">
      <editorial-content-info-box
        v-if="item.index === 'resource_editorial-content'"
        scope="Editorial Content"
        :item="item"
      />
      <pv-data-info-box
        v-if="item.index === 'dataservice'"
        :to="`/dataservices/${item.id}?locale=${locale}`"
        scope="Data service"
        :origin="item.catalog?.country?.label"
        :src="getImg(getCatalogImage(item.catalog))"
        :dataset="{
          title:
            getTranslationFor(item.title, locale, item.catalog?.languages) || item.id,
          description: getTranslationFor(
            item.description,
            locale,
            item.catalog?.languages
          ),
          catalog: getTranslationFor(item.catalog?.title, locale, []),
          createdDate: null,
          updatedDate: null,
          formats: normalizeFormats(item.format),
        }"
        :description-max-length="1000"
        :data-cy="`dataservice@${item.id}`"
        :class="[{ 'is-datasetseries': isInDatasetseries }, 'mt-3']"
      />
      <pv-data-info-box
        v-if="item.index === 'series'"
        :to="`/datasetseries/${item.id}?locale=${locale}`"
        scope="Dataset series"
        :origin="item.catalog?.country?.label"
        :src="getImg(getCatalogImage(item.catalog))"
        :dataset="{
          title:
            getTranslationFor(item.title, locale, item.catalog?.languages) || item.id,
          description: getTranslationFor(
            item.description,
            locale,
            item.catalog?.languages
          ),
          catalog: getTranslationFor(item.catalog?.title, locale, []),
          createdDate: null,
          updatedDate: null,
          formats: normalizeFormats(item.format),
        }"
        :description-max-length="1000"
          :data-cy="`datasetseries@${item.id}`"
          :class="[{ 'is-datasetseries': isInDatasetseries }, 'mt-3']"
      />
      <pv-data-info-box
        v-if="item.index === 'dataset'"
        :to="`/datasets/${item.id}?locale=${locale}`"
        scope="Dataset"
        :origin="item.country?.label"
        :src="getImg(getCatalogImage(item.catalog))"
        :dataset="{
          title:
            getTranslationFor(item.title, locale, item.languages) || item.id,
          description: getTranslationFor(
            item.description,
            locale,
            item.languages
          ),
          catalog: getTranslationFor(item.catalog?.title, locale, []),
          createdDate: item.releaseDate,
          updatedDate: item.modificationDate,
          formats: normalizeFormats(item.distributionFormats),
        }"
        :description-max-length="1000"
        :data-cy="`dataset@${item.id}`"
        :class="[{ 'is-datasetseries': isInDatasetseries }, 'mt-3']"
      />
      <pv-data-info-box
        v-if="item.index === 'catalogue'"
        catalog-mode
        :to="datasetsRoute(item.id)"
        :src="getImg(getCatalogImage(item))"
        scope="Catalogues"
        :origin="item.country?.label"
        :dataset="{
          title: getTranslationFor(
            item.title,
            locale,
            getCatalogLanguages(item)
          ),
          description: getTranslationFor(
            item.description,
            locale,
            getCatalogLanguages(item)
          ),
          catalog: getTranslationFor(
            item.title,
            locale,
            getCatalogLanguages(item)
          ),
          createdDate: null,
          updatedDate: null,
          formats: [],
        }"
        :description-max-length="1000"
        :data-cy="`catalog@${item.id}`"
        :class="[{ 'is-datasetseries': isInDatasetseries }, 'mt-3']"
      />
    </div>
    <div v-if="$route?.query?.mostLiked">
      <pv-data-info-box
        v-for="dataset in likedDatasets"
        :key="dataset.id"
        :to="`/datasets/${dataset.id}?locale=${locale}`"
        :src="getImg(getCatalogImage(dataset.catalog))"
        scope="Dataset"
        :origin="dataset.country?.label"
        :dataset="{
          title:
            getTranslationFor(dataset.title, locale, dataset.languages) ||
            dataset.id,
          description: getTranslationFor(
            dataset.description,
            locale,
            dataset.languages
          ),
          catalog: getTranslationFor(dataset.catalog?.title, locale, []),
          createdDate: dataset.releaseDate,
          updatedDate: dataset.modificationDate,
          formats: normalizeFormats(dataset.distributionFormats),
        }"
        :description-max-length="1000"
        :data-cy="`dataset@${dataset.id}`"
        :class="[{ 'is-datasetseries': isInDatasetseries }, 'mt-3']"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { helpers } from "@piveau/piveau-hub-ui-modules";
import { groupBy, has, toPairs, uniqBy } from "lodash-es";
import EditorialContentInfoBox from "@/components/search/editorial-content/EditorialContentInfoBox";
import { isUnavailableDatasetId } from "@/utils/unavailableDatasets";

const { getImg, getTranslationFor, truncate } = helpers;

export default {
  name: "CombinedList",
  components: { EditorialContentInfoBox },
  props: {
    isDatasetseries: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  data() {
    return {
      baseUrl: this.$env.api.baseUrl,
    };
  },
  computed: {
    ...mapGetters("catalogs", ["getCatalogs"]),
    ...mapGetters("search", ["getEditorialContentItems", "getCombinedItems", "getLikedDatasets"]),
    locale() {
      return this.$route.query.locale;
    },
    isInDatasetseries() {
      return this.isDatasetseries;
    },
    combinedList() {
      return (this.getCombinedItems || []).filter(
        (item) =>
          item &&
          item.id != null &&
          item.index &&
          !(item.index === "dataset" && isUnavailableDatasetId(item.id))
      );
      // const items = [];//this.getDatasets;
      // let datasetIndex = 0;
      // let catalogIndex = 0;
      // let resourceIndex = 0;
      // const datasetCount = this.getDatasets.length;
      // const catalogCount = this.getCatalogs.length;
      // const resourceCount = this.getEditorialContentItems.length;
      // const iterations = Math.max(datasetCount, Math.max(catalogCount, resourceCount));
      // for (let i = 0; i < iterations; ++i) {
      //   if (datasetIndex < datasetCount) {
      //     items.push({...this.getDatasets[datasetIndex++], is: 'dataset'});
      //   }
      //   if (catalogIndex < catalogCount) {
      //     items.push({...this.getCatalogs[catalogIndex++], is: 'catalog'});
      //   }
      //   if (resourceIndex < resourceCount) {
      //     items.push({...this.getEditorialContentItems[resourceIndex++], is: 'editorial-content'});
      //   }
      // }
      // return items;
    },
    likedDatasets() {
      return (this.getLikedDatasets || []).filter(
        (dataset) =>
          dataset &&
          dataset.id != null &&
          !isUnavailableDatasetId(dataset.id)
      );
    },
  },
  methods: {
    getImg,
    getTranslationFor,
    truncate,
    getCatalogImage(catalog) {
      const countryId = catalog?.country?.id?.toLowerCase() === "europe"
        ? "eu"
        : catalog?.country?.id;
      return this.$env.content.catalogs.useCatalogCountries
        ? `${this.$env.content.catalogs.defaultCatalogImagePath}/${
            countryId
              ? countryId
              : this.$env.content.catalogs.defaultCatalogCountryID
          }`
        : `${this.$env.content.catalogs.defaultCatalogImagePath}/${
            has(catalog, "id")
              ? catalog.id
              : this.$env.content.catalogs.defaultCatalogID
          }`;
    },
    /**
     * @description Removes the duplicates of the given array
     * @param array {Array} - The array to remove duplicates from
     * @returns {Array}
     */
    removeDuplicatesOf(array) {
      const formatArray = Array.isArray(array)
        ? array
        : array && typeof array === 'object'
        ? [array]
        : [];
      const correctedFormatArray = formatArray
        .filter((format) => !!format)
        .map((format) => {
          if (typeof format === "string") {
            const normalized = this.getBadgeFormat(format);
            return {
              id: normalized,
              label: normalized,
            };
          }
          const id = this.getBadgeFormat(format.id);
          const label = this.getBadgeFormat(format.label || format.id);
          return {
            ...format,
            id,
            label,
          };
        });
      // sorts after # of occurences (highest occurence first)
      // possibility #1
      const sortedArray = toPairs(groupBy(correctedFormatArray, "id")).sort(
        (a, b) => b[1].length - a[1].length
      );
      const onlyFormatObjectsArray = sortedArray.map((arr) => arr[1][0]);
      // lodash uniqBy funtion removes duplicate id´s from array of objects
      const uniqById = uniqBy(onlyFormatObjectsArray, "id");
      return uniqBy(uniqById, "label");
    },
    /**
     * @description Cuts badge format string (max 8 chars)
     * @param label {String} - badge label or id (e.g. csv)
     */
    getBadgeFormat(label) {
      if (!label) return "";
      return this.truncate(String(label), 8, true);
    },
    normalizeFormats(value) {
      return this.removeDuplicatesOf(value).filter(
        (format) => format && (format.id || format.label)
      );
    },
    datasetsRoute(catalogId) {
      return {
        path: `/catalogues/${catalogId}`,
        query: {
          locale: this.$route.query.locale,
        },
      };
    },
    getCatalogLanguages(catalog) {
      if (!catalog) return [];
      return has(catalog, "country.id")
        ? [catalog.country.id].concat(catalog.languages)
        : catalog.languages || [];
    },
  },
};
</script>
